import { refreshUserToken } from '@rsos/sinatra/src/actions/refreshUserToken';
import { createAccessTokenProvider } from '@rsos/sinatra/src/utils/createAccessTokenProvider';
import { store } from '../../store';

/**
 * The app's single access-token entry point. Both Hermes clients resolve a
 * token through this before every connection attempt, so neither holds token
 * state and neither needs to be told when a token rotates.
 *
 * `store` is dereferenced inside the callback rather than at module load, so
 * this stays safe to import from anywhere in the component tree.
 */
export const getAccessToken = createAccessTokenProvider(refreshToken =>
  store.dispatch(refreshUserToken(refreshToken)),
);

export default getAccessToken;
